const applicablePath = '/komachi-official/teinei-tsushin/'

const setQuery = val => {
  sessionStorage.setItem('lastRequest', val)
}

const getQuery = () => {
  let lastQuery = sessionStorage.getItem('lastRequest')

  if (lastQuery) {
    lastQuery += '&all=1'
  }

  return lastQuery
}

const setScroll = val => {
  sessionStorage.setItem('scroll', val)
}

const getScroll = () => {
  return sessionStorage.getItem('scroll')
}

const reset = () => {
  const isApplicable = !!~window.location.pathname.indexOf(applicablePath)

  if (!isApplicable) {
    sessionStorage.removeItem('lastRequest')
    sessionStorage.removeItem('scroll')
  }
}

export default {
  reset,
  setQuery,
  getQuery,
  setScroll,
  getScroll
}



// WEBPACK FOOTER //
// ./src/komachi-official/assets/scripts/modules/storageManager.js